import api from "./api-config";
import { UserDoctorDto } from "../models/UserDoctorDto";

export const userKcService = {
  createUser: async (userDoctor: UserDoctorDto): Promise<any> => {
    try {
      const response = await api.post(`/kcusers/create`, userDoctor);
      return response.data;
    } catch (error) {
      console.error("Error creating user:", error);
      throw error;
    }
  },

  deleteUser: async (id: string): Promise<void> => {
    try {
      await api.delete(`/kcusers/${id}`);
    } catch (error) {
      console.error("Error deleting user:", error);
      throw error;
    }
  },

  getUserRoles: async (id: string): Promise<any> => {
    try {
      const response = await api.get(`/kcusers/${id}/roles`);
      return response.data;
    } catch (error) {
      console.error("Error getting user roles:", error);
      throw error;
    }
  },

  getUserGroups: async (id: string): Promise<any> => {
    try {
      const response = await api.get(`/kcusers/${id}/groups`);
      return response.data;
    } catch (error) {
      console.error("Error getting user groups:", error);
      throw error;
    }
  },

  activateUser: async (userId: string): Promise<string> => {
    try {
      const response = await api.put(`/kcusers/${userId}/activate`);
      return response.data;
    } catch (error) {
      console.error("Error activating user:", error);
      throw error;
    }
  },

  sendVerificationEmail: async (id: string): Promise<any> => {
    try {
      const response = await api.put(`/kcusers/${id}/send-verification-email`);
      return response.data;
    } catch (error) {
      console.error("Error sending verification email:", error);
      throw error;
    }
  },

  forgotPassword: async (username: string): Promise<any> => {
    try {
      const response = await api.put(`/kcusers/forgot-password`, null, {
        params: { username },
      });
      return response.data;
    } catch (error) {
      console.error("Error initiating forgot password:", error);
      throw error;
    }
  },
};
